(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ornHearts) return;
    window.__ornHearts = true;
    var KEY = 'orane-favoris';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    function paint() {
      var list = read();
      document.querySelectorAll('.orn-heart').forEach(function (b) {
        var on = list.indexOf(b.dataset.handle) > -1;
        if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.orn-heart');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      var list = read();
      var i = list.indexOf(b.dataset.handle);
      if (i > -1) list.splice(i, 1); else list.push(b.dataset.handle);
      write(list);
      paint();
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
    new MutationObserver(function (m) {
      for (var k = 0; k < m.length; k++) { if (m[k].addedNodes.length) { paint(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
